import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref, watch } from 'vue';
import useChapterState from "@/store/modules/useChapterState";
import gsap from 'gsap';


export default /*#__PURE__*/_defineComponent({
  __name: 'HeroLoadingProgress',
  setup(__props) {

const { state } = useChapterState();

const progress = ref<number>(0)
const isFontLoaded = ref<boolean>(false)

const showLoading = () => {
  setTimeout(() => {
    isFontLoaded.value = true
  }, 500)
}

let tween: gsap.core.Tween = null
watch(() => state.loadProgress, (value) => {
  if (tween) {
    tween.kill()
  }
  tween = gsap.to(progress, { value, duration: 1 })
})
watch(() => state.fontLoaded, (value) => {
  if (value) {
    showLoading();
  }
})
onMounted(() => {
  if (state.fontLoaded) {
    showLoading();
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["Loading", { 'show': _unref(state).showLoader && isFontLoaded.value }])
  }, _toDisplayString(Math.floor(progress.value)), 3))
}
}

})